import { memo } from "react";

function ImageCellV2({ src }: { src: string }) {
  return (
    <img
      style={{
        width: "100%",
        borderRadius: "6px",
        maxHeight: "360px",
        objectFit: "contain",
      }}
      alt="task-editor-image"
      src={src}
    />
  );
}

export default memo(ImageCellV2);
